export default __webpack_public_path__ + "static/media/cloud-2.1fc285a9.webp";